import notification from "../../../../assets/sounds/notification.mp3";

export const notificationAudio = new Audio(notification);
